/** @format */

import React, { useEffect } from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fillParamURL } from "../redux/slices/userSlice";

const RutaProtegida = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isLoggedIn = useSelector((state) => state.isLoggedIn);

  useEffect(() => {
    const myParam = searchParams.get("id_grupo");
    if (myParam) {
      dispatch(fillParamURL(myParam));
    }
  }, [dispatch, searchParams]);

  if (!isLoggedIn) {
    return (
      <Navigate
        to='/signin'
        state={{ from: location }}
      />
    );
  }

  return children;
};

export default RutaProtegida;
